import { useMemo } from 'react'
import { getPaperAddon } from '../lib/helpers'
import { usePartialSubscription, useBenefits } from '../stateData/hooks'

export const usePlanInfo = () => {
  const {
    data: { plan, addons, totalPlanPriceAfterTrial, replacementData }
  } = usePartialSubscription()
  const benefitsState = useBenefits()
  const paperAddon = useMemo(() => getPaperAddon(addons), [addons])
  const isPaperAddonOptedIn = paperAddon?.optedIn
  const hasPaperSubscription = replacementData?.hasPaperSubscription
  const paperTrialEndDate = replacementData?.paperTrialEndDate
  const { totalMonths, trialEndDate, transferringMonths } =
    benefitsState.data || {}
  const hasPlanTrial = totalMonths > 0
  const hasPaperTrial =
    (isPaperAddonOptedIn && paperAddon.freeMonths > 0) ||
    (hasPaperSubscription && transferringMonths?.paperFreeMonths > 0)
  const paperAddonFreeMonths = hasPaperSubscription
    ? transferringMonths?.paperFreeMonths
    : paperAddon?.freeMonths
  const paperAddonTrialEndDate = hasPaperSubscription
    ? paperTrialEndDate
    : paperAddon?.trialEndDate

  return {
    plan,
    addons,
    paperAddon,
    totalMonths,
    totalPlanPriceAfterTrial,
    trialEndDate,
    hasPlanTrial,
    hasPaperTrial,
    hasPaperSubscription,
    isPaperAddonOptedIn,
    paperAddonFreeMonths,
    paperAddonTrialEndDate
  }
}
